import React, { useState, useEffect } from "react";
import { Tooltip, IconButton, Paper, Typography, CircularProgress, Box, Grid, Card, CardMedia, CardContent, Button, CardActions, CardActionArea } from "@mui/material";
import { useToken } from "../../items/UseToken";

const HeygenSelection = ({ apiKey, setSelectedId}) => {
    const [loading, setLoading] = useState(false);
    const [avatars, setAvatars] = useState([]);
    const [error, setError] = useState("");
    const { token } = useToken();

    useEffect(() => {
        if (apiKey) {
            fetchAvatars();
        }
    }, [apiKey]);

    const fetchAvatars = async () => {
        setLoading(true);
        setError("");

        try {
            const response = await fetch(`/api/heygen?apiKey=${apiKey}`, {
                headers: {
                    Authorization: "Bearer " + token
                }
            });

            if (!response.ok) {
                throw new Error("Failed to fetch avatars.");
            }

            const data = await response.json();
            setAvatars(data); // backend zwraca już data.data
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };



    return (
        <>
            {loading && <Box sx={{ justifyContent: "center", margin: "1vw", display: "flex", mt: 4 }}><CircularProgress sx={{ mt: 10 }} /></Box>}
            <Grid sx={{ justifyContent: "space-around",  overflowY: "auto" }} alignItems="stretch" container spacing={2}>
               
                {avatars && avatars.map((avatar) => (

                    (
                        <Grid size={6}>
                            <Card sx={{ maxWidth: 100, margin:"2%" }}>
                                <CardActionArea onClick={() => setSelectedId({ ...avatar, key: apiKey })}>
                                    <CardMedia
                                        component="img"
                                        image={avatar.normal_preview}
                                        alt={`AI face for ${avatar.pose_name}`}
                                    />
                                    <CardContent>
                                        <Typography gutterBottom fontSize="x-small"  component="div">
                                            {avatar.pose_name}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                </Grid>
                    )


                ))}
            </Grid>
           
        
            
        </>
    );
};

export default HeygenSelection;
